import React from 'react'
import { Dropdown } from './atoms/Dropdown'
import { Text } from './Typography'
import Box from './Box'
import Avatar from './Avatar'

import styled from 'styled-components'




const StyledContainer = styled.div`
    cursor: pointer;

`

const StyledUserName = styled.div`
    display: block;
    margin-right: 6px;
    max-width: 128px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`

const UserDropdown = ({ username, imageUrl, hideName, ...otherProps }) => {
    

    return (
        <Dropdown {...otherProps }>
            { 
                ({ open }) => ( 
                    <StyledContainer onClick={ open }>
                        <Box display="flex" alignItems="center">
                            { !hideName && <Text><StyledUserName>{ username }</StyledUserName></Text> }
                            <Avatar src={ imageUrl } name={ username } size="tiny" />
                        </Box>
                    </StyledContainer>
                )
            }
        </Dropdown>
    )     
}

export default UserDropdown;